import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { EMAIL } from "@/data/content";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "D & N Constructions respects your privacy. Information you share through our enquiry forms — such as your name, phone number and project details — is used only to respond to your enquiry and discuss your project.",
      "We do not sell or share your personal information with third parties for marketing.",
      "This page is a placeholder. The full Privacy Policy will be published here once finalized by D & N Constructions.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "The content on this website is provided by D & N Constructions for general information about our construction services across Tumakuru, Bengaluru and surrounding areas.",
      "Project details, timelines and estimates are always confirmed directly with our team. Nothing on this website constitutes a binding quotation.",
      "This page is a placeholder. The full Terms & Conditions will be published here once finalized by D & N Constructions.",
    ],
  },
};

export default function Legal({ kind }) {
  const page = CONTENT[kind] || CONTENT.privacy;
  return (
    <>
      <PageHero eyebrow="Legal" title={page.title} />
      <section className="bg-white py-20 md:py-28" data-testid={`legal-${kind}`}>
        <div className="mx-auto max-w-3xl px-5 md:px-8">
          <Reveal>
            {page.body.map((para, i) => (
              <p key={i} className="mb-5 text-base leading-relaxed text-charcoal/70">{para}</p>
            ))}
            <p className="mt-8 text-sm text-charcoal/50">
              Questions? Email us at{" "}
              <a href={`mailto:${EMAIL}`} className="font-semibold text-gold-dark underline-offset-4 hover:underline">{EMAIL}</a>.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
